var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector, OnInit } from '@angular/core';
import { HomeBaseComponent } from './../common-theme/index';
import { Lightbox, LightboxConfig, LightboxEvent, LIGHTBOX_EVENT } from 'angular2-lightbox';
import { ActivatedRoute } from '@angular/router';
import { OpenModalService } from '../common-theme/base-components/shared/modals/open-modal.service';
import { AgencyService } from '../common-theme/api/agency.service';
import { PropertyService } from '../common-theme/api/property.service';
var HomeComponent = /** @class */ (function (_super) {
    __extends(HomeComponent, _super);
    function HomeComponent(injector, agencyService, propertyService, openModalService, route, _lightbox, _lightboxEvent, _lighboxConfig) {
        var _this = _super.call(this, injector, agencyService, route, propertyService, openModalService) || this;
        _this._lightbox = _lightbox;
        _this._lightboxEvent = _lightboxEvent;
        _this._lighboxConfig = _lighboxConfig;
        _this.projects = [];
        _this.initLightbox([
            '/assets/images/home/about_us_1.webp',
            '/assets/images/home/about_us_2.webp',
            '/assets/images/home/about_us_3.webp'
        ]);
        return _this;
    }
    HomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.route.data.forEach(function (data) {
            _this.projects = data.projects.filter(function (project) { return project.map_plan.url; }).sort(function (a, b) { return a.name.localeCompare(b.name); });
            _this.projects.find(function (project) { return project.id === 573; }).map_plan.url = '/assets/images/map_plan/b12.webp';
            _this.projects.find(function (project) { return project.id === 694; }).map_plan.url = '/assets/images/map_plan/b11.webp';
            _this.projects.find(function (project) { return project.id === 933; }).map_plan.url = '/assets/images/map_plan/b12.webp';
        });
        this.setTitle('Dream Residence: garsoniere, apartamente ieftine de vanzare sector 5');
        this.setMetaDescription("Dream Residence este investitia de lunga durata in tine, familia ta si calitatea vietii tale. Ai la dispozitie un complex rezidential intr-o oferta accesibila.");
    };
    HomeComponent.prototype.open = function (index) {
        var _this = this;
        this._lighboxConfig.positionFromTop = 20;
        this._subscription = this._lightboxEvent.lightboxEvent$.subscribe(function (event) { return _this._onReceivedEvent(event); });
        this._lightbox.open(this._albums, index, { wrapAround: true, showImageNumberLabel: true });
    };
    HomeComponent.prototype._onReceivedEvent = function (event) {
        if (event.id === LIGHTBOX_EVENT.CLOSE) {
            this._subscription.unsubscribe();
        }
    };
    HomeComponent.prototype.initLightbox = function (images) {
        this._albums = [];
        for (var _i = 0, images_1 = images; _i < images_1.length; _i++) {
            var image = images_1[_i];
            var album = {
                src: image,
                caption: '',
                thumb: image
            };
            this._albums.push(album);
        }
        this._lighboxConfig.fadeDuration = 1;
    };
    return HomeComponent;
}(HomeBaseComponent));
export { HomeComponent };



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts.pre-build-optimizer.js